﻿import { Component, Inject, OnInit, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd, NavigationCancel } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AppConstants } from './_helpers/app.constants';
import { MenuSettingsService } from './_layout/settings/menu-settings.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { UserService } from './_services/user/user.service';
import { CorporateService } from './_services/corporate/corporate.service';

@Component({
  selector: 'app-main',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.css']
})
@Injectable()
export class AppComponent implements OnInit {
  public _menuSettingsConfig: any;
  public _unsubscribeAll: Subject<any>;
  private _unsubscribeAllMenu: Subject<any>;
  showContent = false;
  public title;
  currentUser: any;

  constructor(private spinner: NgxSpinnerService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public loader: LoadingBarService,
    private deviceService: DeviceDetectorService,
    public _menuSettingsService: MenuSettingsService,
    private titleService: Title,
    private userService: UserService,
    private corporateService: CorporateService,
  ) {
    this._unsubscribeAll = new Subject();
    this._unsubscribeAllMenu = new Subject();
    this.setTitle();
  }
  ngOnInit() {
    this._menuSettingsService.config
      .pipe(takeUntil(this._unsubscribeAllMenu))
      .subscribe((config) => {
        this._menuSettingsConfig = config;
      });
    if (window.localStorage.getItem('currentUser')) {
      this.currentUser = JSON.parse(window.localStorage.currentUser)
      this.userService
        .getUserRole(this.currentUser.roleValue)
        .subscribe((res: any) => {
          console.log("curr user permissions ", res);

          if (res && res.length) {
            window.localStorage.setItem(
              "permissions",
              JSON.stringify(res[0].permissions)
            );
          }
        });
        if(this.currentUser && this.currentUser.organization){
        if (this.currentUser && this.currentUser.organization.toLowerCase() == 'corporate')
        {
          let uid = this.currentUser.tenantId || this.currentUser.uid
          this.corporateService.getCorporateByTenantId(uid)
            .then((org: any) => {
              console.log("kkkkkk", this.currentUser);
              console.log('tenant corporate ', org);
              if (org && org.length) {
                this.corporateService.initProviders(org[0].id);
                window.localStorage.setItem(
                  "currOrganization",
                  JSON.stringify(org[0])
                );
              }
            })

      } else if (this.currentUser && this.currentUser ?.organization.toLowerCase() == 'hotel') {
          let uid = this.currentUser.tenantId || this.currentUser.uid
          this.corporateService.getHotelByTenantId(uid)
            .then((org: any) => {
              console.log('tenant hotel ', org);
              if (org && org.length) {
                window.localStorage.setItem(
                  "currOrganization",
                  JSON.stringify(org[0])
                );
              }
            })
        }
      }
    }
    console.log('getCurrentUser ', );
    // page progress bar percentage
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // set page progress bar loading to start on NavigationStart event router
        this.loader.start();
      }
      if (event instanceof RouteConfigLoadStart) {
        this.loader.increment(35);
      }
      if (event instanceof RouteConfigLoadEnd) {
        this.loader.increment(75);
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // set page progress bar loading to end on NavigationEnd event router
        this.loader.complete();
        this.showContent = true;
        // close menu for mobile view
        if (this.deviceService.isMobile() || window.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH) {
          if (document.body.classList.contains('menu-open')) {
            document.body.classList.remove('menu-open');
            document.body.classList.add('menu-close');
          }
        }
      }
    });
  }

  setTitle() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
          if (!this._menuSettingsConfig.vertical_menu.items[i].submenu &&
            this._menuSettingsConfig.vertical_menu.items[i].page === this.router.url) {
            this.title = this._menuSettingsConfig.vertical_menu.items[i].title;
            break;
          } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu) {
            // Level 1 menu
            for (let j = 0; j < this._menuSettingsConfig.vertical_menu.items[i].submenu.items.length; j++) {
              if (!this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu &&
                this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].page === this.router.url) {
                this.title = this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].title;
                break;
              } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu) {
                // Level 2 menu
                for (let k = 0; k < this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items.length; k++) {
                  if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k].page === this.router.url) {
                    this.title = this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k].title;
                  }
                }
              }
            }
          }
        }
        if (this.title && this.router.url !== '/') {
          this.titleService.setTitle(this.title + ' - CorpCRS');
        } else {
          if (this.router.url === '/') {
            this.title = 'Login';
            this.titleService.setTitle(this.title + ' - CorpCRS');
            this.title = '';
          } else if (this.router.url === '/login') {
            this.title = 'Login';
            this.titleService.setTitle(this.title + ' - CorpCRS');
            this.title = '';
          } else if (this.router.url === '/register') {
            this.title = 'Register';
            this.titleService.setTitle(this.title + ' - CorpCRS');
            this.title = '';
          }
        }
      }
    });
  }
}
